export const uk = {
    'choose-campaign-type': 'Выберите тип кампании'
};
